import React from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import FavoriteCompetitors from '../../_shared/components/FavoriteCompetitors';
import Container from '../../../../components/Container';

const TopTrends = ({ trends, isMobileView }) => (
  <div className="top-trends-wrapper">
    <Container maxWidth={1248}>
      <h1 className="trend-title">{trends.header}</h1>
      {!isEmpty(trends.subheader) && <p className="trend-subtitle">{trends.subheader}</p>}
      <div className="trend-content">
        <FavoriteCompetitors isMobileView={isMobileView} competitors={trends} />
        <div
          className="trend-description"
          dangerouslySetInnerHTML={{
            __html: trends.description,
          }}
        />
      </div>
    </Container>
  </div>
);

TopTrends.propTypes = {
  trends: T.shape({
    header: T.string,
    description: T.string,
    subheader: T.string,
  }).isRequired,
  isMobileView: T.bool.isRequired,
};

export default TopTrends;
